<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>


<script>
import bus from "../src/components/nav/bus"

export default {
    created() {

        // v1.0
        // this.$liff.init(
        //     data => {
        //         console.log("Liff init")
        //         console.log(data.context.userId)
        //         bus.$emit('liff_true', {line_id: data.context.userId})
        //     },
        //     err => {
        //         console.log('Liff init failed at App')
        //     }
        // );
        // "use strict";
        // var userId = '';
        // var params = new URL(location.href); // console.log(location.href);

        // console.log("params1")
        // console.log(params)

        // var liffState = params.searchParams.get('liff.state'); // console.log(lid);
        // // console.log(target);

        // console.log('liff_state2: ')
        // console.log(liffState);

        // if (liffState != undefined) {
        //     console.log('liff_state3')
        //     console.log(liffState); // alert(liffState)

        //     let tmp = liffState.split('?')[1]

        //     console.log('tmp4')
        //     console.log(tmp)

        //     var lid = tmp.split('lid=')[1]

        //     var sp = new URLSearchParams(liffState.split('?')[1]);
        //     console.log('sp4')
        //     console.log(sp)
        //     var co = tmp.get('co');
        //     console.log('lid6')
        //     console.log(lid)
        //     console.log(co)

        // }
        // else {
        //     var lid = params.searchParams.get('lid');
        //     var co = params.searchParams.get('co');
        //     console.log('lid7')
        //     console.log(lid)
        //     console.log(co)
        // }

        // console.log('zzzzzzz')
        // liff.init({
        //     liffId: '1653438082-q1d0nKAd'
        // }).then(function () {
            // console.log('111111')
            // // success
            // // alert('liff init success')
            // if (!liff.isLoggedIn()) {
            // // alert('need login')
            // liff.login({
            //     redirectUri: location.href
            // });
            // return;
            // }

            // if (liffState != undefined && liff.isInClient()) {
            // return;
            // }

            // var xhr = new XMLHttpRequest();
            // var myTimeOut = window.setTimeout(function () {
            // alert('timout-1');
            // xhr.removeEventListener("readystatechange"); // window.location.replace(target);
            // }, 10000);

            // var context = liff.getContext();
            // console.log('get context~')
            // console.log(context);
            // console.log(context.userId);

            // bus.$emit('liff_true', {line_id: context.userId})

            // var userId = context.userId; // alert(userId);
            // alert("target " + target);
            // window.location.replace(target);
            // console.log

            // liff.getProfile().then(function (profile) {
            // var data = JSON.stringify({
            //     "line_id": userId,
            //     "code": code,
            //     "name": profile.displayName,
            //     "picture": profile.pictureUrl,
            // });




            // })["catch"](function (err) {
            // console.log('error', err);
            // });
        // })["catch"](function (err) {
        //     console.log('2222222')
        //     console.log(err); // alert('init error')
        // });
    }
};
</script>